import { get } from 'app/utils/axios/kheti'

const getBlocksByDistrict = async (id: string) => {
  try {
    const res= await get<{ id: string; name: string }[]>(
      `common/v1/district/${id}/blocks`
    );
    return Object.entries(res)
        .filter(([key]) => key !== "api-trace-id")
        .map(([, value]) => value) as { id: string; name: string }[];
  } catch (e) {
    return [];
  }
};

export default getBlocksByDistrict;
